<script lang="ts">
  export let src = '';
  export let ratio = '4x3';
  export let size = 'cover';
  export let position = 'center top';
  export let className = '';
  export let width: string = '100%';
  export let radius: string = '0';
  export let useResize = false;

  $: paddingBottom = getPaddingBottom(ratio);
  $: imgSrc = getImageSrc(src, ratio, useResize);
  $: style = [
    `padding-bottom: ${paddingBottom};`,
    `background-image: url("${imgSrc}");`,
    `background-position: ${position};`,
    `background-size: ${size};`,
    `width: ${width};`,
    `border-radius: ${radius};`,
  ].join(' ');

  function getDimensionsByRatio(ratio: string) {
    const [widthUnit, heightUnit] = ratio.split('x').map((n) => parseInt(n, 10));

    return { widthUnit, heightUnit };
  }

  function getPaddingBottom(ratio: string) {
    const { widthUnit, heightUnit } = getDimensionsByRatio(ratio);

    return `${(heightUnit / widthUnit) * 100}%`;
  }

  function getImageSrc(src: string, ratio: string, useResize: boolean) {
    const { widthUnit, heightUnit } = getDimensionsByRatio(ratio);
    const [width, height] = [widthUnit, heightUnit].map((s) => s * 100);

    if (src) {
      const imageSrc = !useResize
        ? src
        : `https://images.weserv.nl/?url=${src}&w=${width}&h=${height}&fit=cover&a=top`;

      return imageSrc;
    }

    const fileName = `${width}x${height}.png`;

    return `https://placehold.jp/${fileName}`;
  }
</script>

<div class="bg-img {className}" {style} />

<style lang="scss">
  .bg-img {
    width: 100%;
    height: 0;
    box-sizing: border-box;

    &.outlined {
      border: solid 1px var(--theme-text-fields-border);
    }
    &.youtube {
      padding-bottom: 76% !important;
    }

    &.weekly {
      padding-bottom: 0 !important;
      height: 50px !important;
    }
  }
</style>
